import React, { useCallback } from 'react';
import { Button } from '../Button';
import classNames from 'classnames';
import { ChevronLeft } from '../../icons';

export interface IPagination {
  goToFirst: (() => void) | undefined;
  goToLast: (() => void) | undefined;
  goToNext: (() => void) | undefined;
  goToPrevious: (() => void) | undefined;
  goToPage: (page: number) => void;
  totalPages: number;
  totalItems: number;
  currentPage: number;
  currentSearch: string;
  changeLimit: (limit: number) => void;
  changeSearch: (search: string | null) => void;
  currentLimit: number;
}

export const Pagination = (props: {
  pagination: IPagination;
  onPageChange?: () => void;
}) => {
  const {
    goToFirst,
    goToLast,
    goToNext,
    goToPrevious,
    totalPages,
    currentPage,
  } = props.pagination;

  const onPageChange = useCallback(
    (cb?: () => void) => {
      cb?.();
      props.onPageChange?.();
    },
    [props.onPageChange]
  );

  return (
    <div className="flex gap-1" id="pagination">
      <Button
        variant="base"
        disabled={!goToPrevious}
        className={classNames('h-10 w-10 !px-3')}
        onClick={() => onPageChange(goToPrevious)}
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>
      {currentPage !== 1 && (
        <Button
          variant="base"
          className={classNames('h-10 w-10 !px-3 !text-xs')}
          disabled={!goToFirst}
          onClick={() => onPageChange(goToFirst)}
        >
          1
        </Button>
      )}
      <Button
        variant="outline"
        className={classNames('h-10 w-10 !px-3 !text-xs')}
      >
        {currentPage}
      </Button>
      {currentPage !== totalPages && totalPages !== 0 && (
        <Button
          variant="base"
          className={classNames('h-10 w-10 !px-3 !text-xs')}
          disabled={!goToLast}
          onClick={() => onPageChange(goToLast)}
        >
          {totalPages}
        </Button>
      )}
      <Button
        variant="base"
        className={classNames('h-10 w-10 !px-3')}
        disabled={!goToNext}
        onClick={() => onPageChange(goToNext)}
      >
        <ChevronLeft className="rotate-180 w-4 h-4" />
      </Button>
    </div>
  );
};
